import { AfterViewInit, Component, Inject, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FhPasswordRegexService } from '../../services/fh-password-regex.service';

import { LabelConfigModel } from '@fh-client-interaction-frontends/fh-label';
import { FhInputConfigModel } from '@fh-client-interaction-frontends/input-config';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';

@Component({
  selector: 'ui-fh-input-password',
  templateUrl: './fh-input-password.component.html',
  styleUrls: ['./fh-input-password.component.scss']
})
export class FhInputPasswordComponent implements OnInit, AfterViewInit {
  @Input() inputConfig: FhInputConfigModel = new FhInputConfigModel();
  @Input() showFeedback: boolean = false;
  @Input() removeAutoComplete = '';
  @Input() isRequired: boolean = false;
  appConfig: EnvironmentModel = new EnvironmentModel();
  labelConfigs: LabelConfigModel = new LabelConfigModel();
  value: any;

  checkLower = true;
  checkUpper = true;
  checkNumeric = true;
  checkSymbol = true;
  checkQuantity = true;
  checkSpace = true;

  password = '';

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel,
              private fhPasswordRegexService: FhPasswordRegexService) {
    this.appConfig = appConfigTemp;
  }

  ngOnInit(): void {
    if (this.inputConfig.passwordFeedback) {
      this.inputConfig?.control?.addValidators([
        Validators.pattern(
          this.fhPasswordRegexService.GetEntireRegex(this.checkLower, this.checkUpper, this.checkNumeric, this.checkSymbol, this.checkQuantity, this.checkSpace)
        )
      ]);
    }

    this.getLabelConfigs();
  }
  ngAfterViewInit() {
    document.getElementById(this.inputConfig.idInputPassword)?.setAttribute('autocomplete', 'off');
  }

  getLabelConfigs() {
    this.labelConfigs = {
      class: this.inputConfig?.labelClass ? this.inputConfig?.labelClass + ' label-padding' : 'label-padding',
      label: this.isRequired ? this.inputConfig?.label + ' *' : this.inputConfig?.label
    } as LabelConfigModel;
    return this.labelConfigs;
  }
}
